import dayjs, { Dayjs } from 'dayjs';

export interface StampDateTime {
  date: Date | Dayjs | null;
  time: Date | Dayjs | null;
}

/**
 * The anchor is the first stamp (in drawer order) with a recorded time. A stamp
 * that gains a time but has no date yet defaults to the anchor stamp's date.
 */
function getAnchorStampIndex(stamps: StampDateTime[]) {
  const anchorIndex = stamps.findIndex((stamp) => Boolean(stamp.time));

  return anchorIndex === -1 ? null : anchorIndex;
}

export function getAnchorStampDate(stamps: StampDateTime[]) {
  const anchorIndex = getAnchorStampIndex(stamps);

  if (anchorIndex === null) {
    return null;
  }

  const anchorDate = stamps[anchorIndex].date;

  return anchorDate ? dayjs.tz(anchorDate) : null;
}
